import { Check } from "@mui/icons-material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import {
    Container,
    Icon as Icone,
    StepConnector,
    StepIconProps,
    Typography,
    stepConnectorClasses,
    styled,
} from "@mui/material";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import ConsignadoIcon from "components/Icons/ConsignadoIcon";
import FinancasIcon from "components/Icons/FinancasIcon";
import GestaoReceberIcon from "components/Icons/GestaoReceberIcon";
import PreVendaIcon from "components/Icons/PreVendaIcon";
import HeaderOuBannerDependendoDaInterpretacaoH1, {
    headerOuBannerDependendoDaInterpretacaoH1defaultFontSize,
} from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { FinancasTitle } from "pages/financas/financas.model";
import VendasIcon from "pages/Venda/VendasIcon";
import { useAppSelector } from "redux/hooks";
import { customColors, theme } from "theme";
import useCustomLocation from "utils/useCustomLocation";

export interface StepperProps {
  stepsLabel: Array<string>;
  activeStep: number;
}

const StepperComponent = ({ stepsLabel, activeStep }: StepperProps) => {
  const {
    isTelaRegistraVenda,
    isTelaPagamento,
    isTelaVenda,
    isTelaConfiguracoes,
    isTelaCaixa,
    isTelaValePresente,
    isTelaBuscaAvancadaValePresente,
    isTelaRelatorioFechamentoCaixa,
    isTelaPreVenda,
    isTelaRegistraConsignado,
    isTelaConsignado,
    isTelaConferencia,
    isTelaDevolucaoConsignado,
    isTelaFinancas,
    isTelaFinancasGestaoReceber,
  } = useCustomLocation();
  const valePresente = useAppSelector((s) => s.valePresente.valePresente);

  return (
    <Container
      maxWidth="xl"
      sx={{
        marginTop: "20px",
      }}
    >
      {!isTelaConfiguracoes() &&
        !isTelaCaixa() &&
        (isTelaRegistraVenda() || isTelaPagamento()) && (
          <Box
            sx={{
              width: "100%",
              borderTop: `1px solid ${customColors.cinzaClaro}`,
              borderBottom: `1px solid ${customColors.cinzaClaro}`,
              padding: "15px 0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <Stepper
              activeStep={activeStep}
              sx={{
                width: "60%",
              }}
              connector={<Connector />}
            >
              {stepsLabel.map((label, index) => {
                return (
                  <Step key={label + index} id={`${label}_${index}`}>
                    <StepLabel
                      slotProps={{
                        label: { id: `label_${label}_${index}` },
                      }}
                      id={`steplabel_${label}_${index}`}
                      StepIconComponent={Icon}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
        )}

      {isTelaVenda() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="venda"
          customIcon={
            <VendasIcon
              id="vendaShoppingCarIcon"
              color={theme.palette.text.primary}
              fontSize={
                headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.large
              }
            />
          }
          label="Vendas"
        />
      )}

      {isTelaValePresente() && (
        <Box
          sx={{
            width: "100%",
            borderTop: `1px solid ${customColors.cinzaClaro}`,
            borderBottom: `1px solid ${customColors.cinzaClaro}`,
            padding: "15px 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <Box
            id="vale-presente-box"
            sx={{
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Typography
              id="title-vale-presente"
              sx={{ color: theme.palette.text.primary, userSelect: "none" }}
            >
              Recebimento de vale presente
            </Typography>
            <Typography
              id="cliente-vale-presente"
              sx={{
                color: theme.palette.text.primary,
                fontSize: "12px",
                userSelect: "none",
                maxWidth: "400px",
              }}
            >
              Cliente: {valePresente?.cliente.descritivo}
            </Typography>
          </Box>
        </Box>
      )}

      {isTelaBuscaAvancadaValePresente() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="vale-presente-busca-avancada"
          customIcon={
            <CardGiftcardIcon
              sx={{
                color: theme.palette.text.primary,
                fontSize:
                  headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal,
              }}
            />
          }
          label="Busca avançada - Crédito do cliente"
        />
      )}

      {isTelaRelatorioFechamentoCaixa() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="relatorio-fechamento-caixa"
          customIcon={
            <Icone
              className="fa-regular fa-file-lines"
              sx={{
                color: theme.palette.text.primary,
                fontSize:
                  headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal,
              }}
            />
          }
          label="Relatório de fechamento de caixa"
        />
      )}

      {isTelaPreVenda() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="pre-venda"
          customIcon={
            <PreVendaIcon
              id="side_menu_pre_venda_icon"
              color={theme.palette.text.primary}
              fontSize={
                headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.large
              }
            />
          }
          label="Pré-venda"
          maxHeight="35px"
        />
      )}

      {(isTelaRegistraConsignado() || isTelaConsignado()) && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="consignado"
          iconClassName="fa-solid fa-bag-shopping"
          customIcon={
            <ConsignadoIcon
              id="side_menu_consignado_icon"
              color={theme.palette.text.primary}
              fontSize={
                headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.large
              }
            />
          }
          label="Consignado"
        />
      )}

      {isTelaDevolucaoConsignado() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="devolucao-consignado"
          iconClassName="fa-solid fa-reply"
          label="Devolução consignado"
        />
      )}
      {isTelaConferencia() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="conferencia"
          iconClassName="fa-solid fa-list-check"
          label="Conferência"
        />
      )}

      {isTelaFinancas() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="Finanças"
          label="Finanças"
          customIcon={
            <FinancasIcon
              id="financas-icon"
              color={theme.palette.text.primary}
              fontSize={
                headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.large
              }
            />
          }
        />
      )}
      {isTelaFinancasGestaoReceber() && (
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="financas-gestor-receber"
          label={FinancasTitle.GESTAO_DO_RECEBER}
          customIcon={
            <GestaoReceberIcon
              id="financas-gestor-receber-icon"
              color={theme.palette.text.primary}
              fontSize={
                headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.large
              }
            />
          }
        />
      )}
    </Container>
  );
};

export default StepperComponent;

const Connector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },

  [`& .${stepConnectorClasses.line}`]: {
    borderColor: customColors.cinzaClaro,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const IconRoot = styled("div")<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    "& .stepIcon": {
      color: theme.palette.text.primary,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 30,
      aspectRatio: "1/1",
      borderRadius: 50,
      backgroundColor: customColors.cinzaClaro,
      fontSize: 20,
      ...(ownerState.active && {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.primary.main,
      }),
      "&__completedIcon": {
        color: theme.palette.primary.main,
        fontSize: 25,
      },
    },
  })
);

function Icon({ active, completed, icon }: StepIconProps) {
  return (
    <IconRoot ownerState={{ active }}>
      {completed ? (
        <Check className="stepIcon__completedIcon" />
      ) : (
        <div className="stepIcon">{icon}</div>
      )}
    </IconRoot>
  );
}
